import React, { createContext, useState, ReactNode, useEffect } from 'react';
import { DifficultyCircuitHeader, GymExtraMinimalProps, GymMinimalProps, RouteSetterProps } from '../constants/types';
import { pages } from '../constants/Consts';
import { getRouteSetterGymFilterInfo, getRouteSetterUserInfo } from '../data/getAxiosRequests';

interface GlobalContextProps {
    user: string | null;
    setUser: React.Dispatch<React.SetStateAction<string | null>>;
    currentGym : GymMinimalProps | null
    setCurrentGym : React.Dispatch<React.SetStateAction<GymMinimalProps | null>>;
    currentPage : string | null
    setCurrentPage : React.Dispatch<React.SetStateAction<string | null>>;
    gymsFilterInfo : GymMinimalProps[] | undefined,
    setGymsFilterInfo : React.Dispatch<React.SetStateAction<GymMinimalProps[] | undefined>>;
    routeSetterInfo :  RouteSetterProps |undefined
    setRouteSetterInfo : React.Dispatch<React.SetStateAction< RouteSetterProps |undefined>>;
    lastDifficultyChecked : DifficultyCircuitHeader | undefined
    setLastDifficultyChecked :  React.Dispatch<React.SetStateAction< DifficultyCircuitHeader |undefined>>;
    isInitialized: boolean;

    // Add other global state variables and their setters here
}

export const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);

export const GlobalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<string | null>(null);
    const [currentGym, setCurrentGym] = useState <GymMinimalProps | null > (null)
    const [currentPage, setCurrentPage ] = useState<string | null>(null);
    const [gymsFilterInfo, setGymsFilterInfo] = useState<GymMinimalProps[] | undefined >([])
    const [routeSetterInfo, setRouteSetterInfo] = useState<RouteSetterProps | undefined >(undefined)
    const [lastDifficultyChecked, setLastDifficultyChecked] = useState<DifficultyCircuitHeader | undefined>(undefined)
    const [isInitialized, setIsInitialized] = useState(false);




    useEffect(()=>{
        if (user){
            getRouteSetterGymFilterInfo(user).then(data => {
            setGymsFilterInfo(data)})
            getRouteSetterUserInfo(user).then(data => {
            setRouteSetterInfo(data)})
        }


    },[user])
    // Add other state variables here

    // Initialize user from localStorage on mount
    useEffect(()=>{
        const userUuid = localStorage.getItem('user')
        if(userUuid){
            setUser(JSON.parse(userUuid))
        }
        // Mark as initialized whether or not user exists
        setIsInitialized(true)
    },[])


    const values ={
        user,
        setUser,
        currentGym,
        setCurrentGym,
        currentPage,
        setCurrentPage,
        gymsFilterInfo,
        setGymsFilterInfo,
        routeSetterInfo,
        setRouteSetterInfo,
        lastDifficultyChecked,
        setLastDifficultyChecked,
        isInitialized
    }

    // Don't render children until we've checked localStorage for user
    if (!isInitialized) {
        return null;
    }

    return (
        <GlobalContext.Provider value={values}>
            {children}
        </GlobalContext.Provider>
    );
};